/**
* 图表界面
*/ 
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据可视化</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索，切换 -->
    <el-row :gutter="23">
      <el-col :span="24">
        <div class="stbgc">
          <el-row :gutter="23">
            <el-col :span="5">
              <div class="head">
                <div class="name">
                  总收入
                </div>
                <div class="data">
                  <countTo :startVal='0' :endVal='this.totaldata.totalCount' :duration='2000'></countTo>
                </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="head color1">
                <div class="name">
                  积分池
                </div>
                <div class="data">
                  <countTo :startVal='0' :endVal='this.totaldata.totalPoints' :duration='2000'></countTo>

                </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="head color2">
                <div class="name">
                  用户量
                </div>
                <div class="data">
                  <countTo :startVal='0' :endVal='this.totaldata.userCount' :duration='2000'></countTo>

                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="head color3">
                <div class="name">
                  订单量
                </div>
                <div class="data">
                  <countTo :startVal='0' :endVal='this.totaldata.orderCount' :duration='2000'></countTo>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="head color4">
                <div class="name">
                  代办
                </div>
                <div class="data">
                  <countTo :startVal='0' :endVal='this.totaldata.unaddressedFeedbackTotal' :duration='2000'></countTo>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 统计图 -->
    <el-row :gutter="23">
      <el-col :span="8" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="SCEchart"></div>
        </div>
      </el-col>
      <el-col :span="8" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="SUMEchart"></div>
        </div>
      </el-col>
      <el-col :span="8" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="ClickEchart"></div>
        </div>
      </el-col>
    </el-row>
    <!-- 统计图 -->
    <div style="margin-top: 60px;">
      <el-row :gutter="23">
        <el-col :span="8" class="text-c">
          <el-card style="margin-bottom: 20px;">
            <div slot="header">
              <span style="font-weight: 900;font-size: 18px;">最新反馈内容</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="gofeedback">查看详情</el-button>
            </div>
            <div v-for="(item, index) in feedbacklist" :key="index">
              <div class="feedbacklist">
                <span>{{ item.content }}</span><span>{{ item.createTime | timestampToTime }}</span>
              </div>
            </div>
          </el-card>
          <el-card>
            <div slot="header">
              <span style="font-weight: 900;font-size: 18px;">最新订单列表</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="goorder">查看详情</el-button>
            </div>
            <div v-for="(item, index) in orderlist" :key="index">
              <div>
                <div class="feedbacklist">
                  <span>{{ item.title }}</span> <el-button type="success" size="mini" round
                    v-if="item.orderStatus == '已支付'">{{
                      item.orderStatus }}</el-button><el-button type="danger" size="mini" round v-else>{{ item.orderStatus
  }}</el-button>
                </div>

              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16" class="text-c">
          <el-card>
            <div ref="incomechart" style="width:100%; height: 300px;"></div>

          </el-card>
          <el-card style="margin-top: 20px;">
            <div ref="scorechart" style="width: 100; height: 300px;"></div>

          </el-card>
        </el-col>

        <!-- <el-col :span="8" class="text-c">
          <el-card>
            <div ref="scorechart" style="width: 300px; height: 400px;"></div>
          </el-card>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { getTotalapi, } from '../../api/userMG'
import { OrderList, FeedbackList, weekTotalCount, weekScoreCount } from '../../api/payMG'
import Chart from 'echarts'
import countTo from 'vue-count-to';
export default {
  name: "welcome",
  data() {
    return {
      totaldata: {
        totalCount: 0,
        totalPoints: 0,
        userCount: 0,
        orderCount: 0,
        unaddressedFeedbackTotal: 0
      },
      // 订单参数
      orderdata: {
        tradeNo: '',
        pageNo: 1,
        pageSize: 8,
        userName: ''
      },
      orderlist: [],
      feedbackdata: {
        ssid: "",
        content: "",
        orderNo: "",
        status: "",
        pageNo: 1,
        pageSize: 2
      },
      feedbacklist: [],
      Totaloption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' }
        },
        xAxis: {
          // type: 'time',
          name: '时间',
          data: []
        },
        yAxis: {
          name: '金额',
          type: 'value'
        },
        color: [
          '#c23531',
        ],
        series: [
          {
            data: [],
            type: 'line',
            itemStyle: {
              color: '#5880B6' // 设置线条颜色
            }
          }
        ]
      },
      Scoreoption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' }
        },
        xAxis: {

          data: [],
          name: '时间',
        },
        yAxis: {
          type: 'value',
          name: '积分'
        },
        series: [
          {
            data: [],
            type: 'line',
          }
        ]
      }
    }
  },
  // 导入组件
  components: {
    // 点聚合组件
    countTo
  },

  // 挂载结束状态(里面是操作)
  mounted() {

    this.getweekTotalCount()
    this.getweekScoreCount()




    this.getTotal()
    this.getOrderList()
    this.getFeedbackList()
  },
  // 里面的函数只有调用才会执行
  methods: {
    getTotal() {
      getTotalapi().then((res) => {
        this.totaldata = res.data
      })
    },
    getOrderList() {
      OrderList(this.orderdata).then(res => {
        this.orderlist = res.data.lists
      })
    },
    getFeedbackList() {
      FeedbackList(this.feedbackdata).then(res => {
        this.feedbacklist = res.data.lists
      })
    },
    gofeedback() {
      this.$router.push('/feedback/Feedback')
    },
    goorder() {
      this.$router.push('/pay/Order')
    },
    getweekScoreCount() {
      weekScoreCount().then(res => {
        const data = res.data
        data.forEach(item => {
          this.Scoreoption.series[0].data.push(item.dailyTotals)
          this.Scoreoption.xAxis.data.push(item.time)
          const myChart = Chart.init(this.$refs.scorechart)
          myChart.setOption(this.Scoreoption)

        })
      })
    },
    getweekTotalCount() {
      weekTotalCount().then(res => {
        const data = res.data
        data.forEach(item => {
          this.Totaloption.series[0].data.push(item.dailyTotals)
          this.Totaloption.xAxis.data.push(item.time)
          const myChart = Chart.init(this.$refs.incomechart)
          myChart.setOption(this.Totaloption)

        })
      })
    }
  }
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.stbgc {
  margin-top: 20px;
  height: 100px;
}

.feedbacklist {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(149, 138, 138, 0.23);
  padding: 10px 0;
}

.feedbacklist :nth-child(1) {
  width: 60%;
  /* 定义父容器宽度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.head {
  background: #578ebe;
  width: 100%;
  height: 140px;
  box-sizing: border-box;
  border-radius: 20px;
  color: #fff;
}

.head .name {
  font-size: 20px;
  font-weight: bold;
  padding: 10px;
}

.head .data {
  text-align: right;
  font-size: 40px;
  padding: 10px;
  font-weight: 900;
}

.color1 {
  background: #e35b5a;
}

.color2 {
  background: #4ec1b9;
}



.color3 {
  background: #b5a2d8;
}

.color4 {
  background: #e28572;
}
</style>


// WEBPACK FOOTER //
// src/views/charts/statistics.vue